import React from 'react';
import './About.css'
import Hero from '../../../../components/home/Hero/Hero';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useLangLink from "../../../../utils/useLangLink";
import fileIcon from '../../../../assets/images/fileIcon.svg'
import globalIcon from '../../../../assets/images/globalIcon.svg'
import tableIcon from '../../../../assets/images/tableIcon.svg'
import whoWeAreImg1 from '../../../../assets/images/about/who-we-are1.png'
import whoWeAreImg2 from '../../../../assets/images/about/who-we-are2.png'
import whoWeAreImg3 from '../../../../assets/images/about/who-we-are3.png'
import whatWeDoImg1 from '../../../../assets/images/about/what-we-do1.png'
import whatWeDoImg2 from '../../../../assets/images/about/what-we-do2.png'
import whatWeDoImg3 from '../../../../assets/images/about/what-we-do3.png'
import whatWeDoImg4 from '../../../../assets/images/about/what-we-do4.png'
import whatWeDoImg5 from '../../../../assets/images/about/what-we-do5.png'
import globalMapImg from '../../../../assets/images/about/world-map.png'
import westernSaharaFlag from '../../../../assets/images/about/westernFlagIcon.svg'
import mwaliFlagIcon from '../../../../assets/images/about/mwaliFlagIcon.svg'
import anjouanFlagIcon from '../../../../assets/images/about/turkeyFlagIcon.svg'
import maltaFlagIcon from '../../../../assets/images/about/maltaFlagIcon.svg'
import cyprusFlagIcon from '../../../../assets/images/about/cuprysFlagIcon.svg'
import gilbarFlagIcon from '../../../../assets/images/about/gibraltarFlagIcon.svg'
import isleFlagIcon from '../../../../assets/images/about/isleFlagIcon.svg'
import panamaFlagIcon from '../../../../assets/images/about/panamaFlagIcon.svg'
import seychellesFlagIcon from '../../../../assets/images/about/SeychlessFlagIcon.svg'
import maurituisFlagIcon from '../../../../assets/images/about/mauritiusFlagIcon.svg'
import luciaFlagIcon from '../../../../assets/images/about/luciaFlagIcon.svg'
import vincentFlagIcon from '../../../../assets/images/about/vincentFlagIcon.svg'
import uaeFlagIcon from '../../../../assets/images/about/uaeFlagIcon.svg'
import singaporeFlagIcon from '../../../../assets/images/about/singaporeFlagIcon.svg'
import indonesiaFlagIcon from '../../../../assets/images/about/indonesiaFlagIcon.svg'
import ukFlagIcon from '../../../../assets/images/about/ukFlagIcon.svg'
import spainFlagIcon from '../../../../assets/images/about/spainFlagIcon.svg'
import greeceFlagicon from '../../../../assets/images/about/greeceFlagIcon.svg'
import italyFlagIcon from '../../../../assets/images/about/italyFlagIcon.svg'
import whiteArrow from '../../../../assets/images/Home/whiteArrow.svg'
import Discover from '../../../../components/Discover/Discover';
import OherPractices from '../../../../components/OtherPractices/OherPractices';
import ContactFormWithBackground from '../../../../components/ContactFormWithBackgroundGray/ContactFormWithBackground';
import SEO from "../../../../utils/SEO";




function About() {

    const { t } = useTranslation();
    const lp = useLangLink();
    const tp = (k, d) => t(`pages.about.${k}`, d);

    const breadcrumbs = [
        { name: tp('breadcrumb.home', 'Home'), link: '/' },
        { name: tp('breadcrumb.self', 'About the Company'), link: '/about' },
    ];

    const protectingItemsArr = (tp('protecting.items', { returnObjects: true }) || []).map((title, i) => ({
        id: i + 1, img: [fileIcon, globalIcon, tableIcon][i], title,
    }));

    const whatWeDoImgs = [whatWeDoImg1, whatWeDoImg2, whatWeDoImg3, whatWeDoImg4, whatWeDoImg5];
    const whatWeDoItemsArr = (tp('whatWeDo.items', { returnObjects: true }) || []).map((it, i) => ({
        id: i + 1, ...it, img: whatWeDoImgs[i],
    }));

    const whyClientsTrustArr = (tp('whyTrust.items', { returnObjects: true }) || []).map((it, i) => ({
        id: i + 1, point: `(0${i + 1})`, ...it,
    }));

    const countryFlags = [westernSaharaFlag, mwaliFlagIcon, anjouanFlagIcon, maltaFlagIcon, cyprusFlagIcon, gilbarFlagIcon, isleFlagIcon, panamaFlagIcon, seychellesFlagIcon, maurituisFlagIcon, luciaFlagIcon, vincentFlagIcon, uaeFlagIcon, singaporeFlagIcon, indonesiaFlagIcon, ukFlagIcon, spainFlagIcon, greeceFlagicon, italyFlagIcon];
    const contrysArr = (tp('presence.countries', { returnObjects: true }) || []).map((title, i) => ({
        id: i + 1, title, img: countryFlags[i],
    }));

    const meetOurClientsKeysArr = (tp('meet.items', { returnObjects: true }) || []).map((it, i) => ({
        id: i + 1, point: `(0${i + 1})`, ...it,
    }));

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/about"
            />

            <Hero breadcrumbs={breadcrumbs} contentCenter={true} pretitle={tp('hero.pretitle')} title={tp('hero.title')} descr={tp('hero.descr')} backgroundImg='aboutHeader' />
           
            <section
                className='about-section section'
            >
                <div className='protecting-assets-container'>
                    <h2 className='protecting-title'>
                        {tp('protecting.title')}
                    </h2>
                    <div className='protecting-assets-descr-wrapper'>
                        <p className='protecting-assets-descr'>
                            {tp('protecting.descr')}
                        </p>
                    </div>
                    <div className='protecting-assets-keys-row'>
                        {protectingItemsArr.map((item) => (
                            <div className='protecting-assets-item' key={item.id}>
                                <div className='protecting-assets-item-img-wrapper'>
                                    <img src={item.img} alt={item.title} />
                                </div>
                                <h3 className='protecting-assets-item-title'>
                                    {item.title}
                                </h3>
                            </div>
                        ))}
                        
                    </div>
                </div>
                <div className='who-we-are-background'>
                    <div className='who-we-are-container'>
                        <div className='who-we-are-item'>
                            <div className='who-we-are-img-wrapper'>
                                <img src={whoWeAreImg1} alt={tp('whoWeAre.alt1')} />
                            </div>
                            <div className='who-we-are-item-content'>
                                <h3 className='who-we-are-item-title'>
                                    {tp('whoWeAre.wa.title')}
                                </h3>
                                <p>
                                    {tp('whoWeAre.wa.p1')}
                                </p><br/>
                                <p>
                                    {tp('whoWeAre.wa.p2')}
                                </p>
                            </div>
                        </div>
                        <div className='who-we-are-item'>
                            <div className='who-we-are-img-wrapper'>
                                <img src={whoWeAreImg2} alt={tp('whoWeAre.alt2')} />
                            </div>
                            <div className='who-we-are-item-content'>
                                <h3 className='who-we-are-item-title'>
                                    {tp('whoWeAre.vision.title')}
                                </h3>
                                <p>
                                    {tp('whoWeAre.vision.p')}
                                </p>
                            </div>
                            
                        </div>
                        <div className='who-we-are-item'>
                            <div className='who-we-are-img-wrapper'>
                                <img src={whoWeAreImg3} alt={tp('whoWeAre.alt3')} />
                            </div>
                           <div className='who-we-are-item-content'>
                                 <h3 className='who-we-are-item-title'>
                                    {tp('whoWeAre.mission.title')}
                                </h3>
                                <p>
                                    {tp('whoWeAre.mission.p')}
                                </p>
                           </div>
                            
                        </div>
                    </div>
                </div>
                <div className='what-we-do-container'>
                    <h2 className='what-we-do-title'>
                        {tp('whatWeDo.title')}
                    </h2>
                    <span className='what-we-do-sub-title'>
                        {tp('whatWeDo.subtitle')}
                    </span>
                    {whatWeDoItemsArr.map((itemBlock) => (
                        <div className='what-we-do-item-block' key={itemBlock.id}>
                            <div className='what-we-do-item-left'>
                                <h3 className='what-we-do-item-title'>
                                    {itemBlock.title}
                                </h3>
                                <p className='what-we-do-item-descr'>
                                    {itemBlock.descr}
                                </p>
                            </div>
                            <div className='what-we-do-item-right'>
                                <img src={itemBlock.img} alt={itemBlock.title} />
                            </div>
                        </div>
                    ) )}
                    
                </div>
                <div className='why-clients-trust-background'>
                    <div className='why-clients-trust-container'>
                        <div className='why-clients-trust-left'>
                            <h2 className='why-clients-trust-title'>
                                {tp('whyTrust.title')}
                            </h2>
                            <span>
                                {tp('whyTrust.subtitle')}
                            </span>
                        </div>
                        <div className='why-clients-trust-right'>
                            {whyClientsTrustArr.map((item) => (
                                <div className='why-clients-turst-item' key={item.id}>
                                    <span className='why-clients-trust-item-point'>
                                        {item.point}
                                    </span>
                                    <h3 className='why-clients-trust-item-title'>
                                        {item.title}
                                    </h3>
                                    <p className='why-clients-trust-item-descr'>
                                        {item.descr}
                                    </p>
                                </div>
                            ))}
                            
                        </div>
                    </div>
                </div>
                <div className='global-presence-container'>
                    <div className='global-presence-left'>
                        <h2 className='global-presence-title'>
                            {tp('presence.title')}
                        </h2>
                        <span>
                            {tp('presence.subtitle')}
                        </span>
                        <div className='global-presence-countrys-row'>
                            {contrysArr.map((country) => (
                                <div className='country-item' key={country.id}>
                                    <div className='country-image-wrapper'>
                                        <img src={country.img} alt={country.title} />
                                    </div>
                                    <span className='title-country'>
                                        {country.title}
                                    </span>
                                </div>
                            ))}
                            
                        </div>
                    </div>
                    <div className='global-presence-right'>
                            <img src={globalMapImg} alt={tp('presence.mapAlt')} />
                    </div>
                </div>
                <div className='meet-our-clients-background'>
                    <div className='meet-our-content-container'>
                        <h2 className='meet-our-title'>
                            {tp('meet.title')}
                        </h2>
                        <span className='meet-our-sub-title'>
                            {tp('meet.subtitle')}
                        </span>
                        <div className='meet-keys-row'>
                            {meetOurClientsKeysArr.map((item) => (
                                 <div className='meet-keys-item' key={item.id}>
                                    <div className='meet-keys-left'>
                                    <span>
                                        {item.point}
                                    </span>
                                    <h3>
                                        {item.title}
                                    </h3>
                                    </div>
                                    <div className='meet-keys-left'>
                                        {item.descr}
                                    </div>
                                </div>   
                            ))} 
                        </div>
                    </div>
                </div>
                <div className='offshore-advisory-background'>
                    <div className='offshore-advisory-container'>
                        <h2 className='offshore-advisory-title'>
                            {tp('cta.title')}
                        </h2>
                        <div className='offshore-advisory-btn-wrapper'>
                            <Link to={lp('/newsletter')}>
                                {tp('cta.button')}
                                <img src={whiteArrow} alt='' />
                            </Link>
                        </div>
                    </div>
                </div>
                <Discover />
                <OherPractices />
                <ContactFormWithBackground />
            </section>
            {/* <Footer /> */}
        </main>
    );
}

export default About;
